<ds-icon-button
  [tooltipLabel]="'A11Y.TOOLTIP.advancedSearch' | translate"
  [ariaLabel]="'A11Y.TOOLTIP.advancedSearch' | translate"
  (click)="openSearchFilterDialog()"
  color="accent"
  icon="manage_search" />
